/* sansoti — draft-only kleur-swatches voor de variant-kiezer (Horizon/VL).
   Vult lege swatch-cirkels met een kleur o.b.v. de Poolse kleurnaam. Raakt GEEN productdata;
   variant-FOTO-swatches blijven ongemoeid. */
(function () {
  var CMAP = [
    ['czarn','#1c1c1c'],['biał','#f4f1ea'],['bial','#f4f1ea'],['złot','#c9a24e'],['zlot','#c9a24e'],
    ['różowe zło','#e8c6a0'],['srebrn','#c3c3c3'],['srebn','#c3c3c3'],['czerwon','#b23b3b'],['zielon','#4e7a4e'],
    ['żółt','#e3c04a'],['zółt','#e3c04a'],['zolt','#e3c04a'],['żolt','#e3c04a'],
    ['różow','#e0a3b8'],['rozow','#e0a3b8'],['niebiesk','#4a6a9a'],['błękit','#7fa8c9'],['blekit','#7fa8c9'],
    ['granat','#28314d'],['szar','#9b9b9b'],['brązow','#7a5230'],['brazow','#7a5230'],['brąz','#7a5230'],['braz','#7a5230'],
    ['beżow','#d8c7a8'],['bezow','#d8c7a8'],['orzech','#6a4a2f'],['buk','#c8a87a'],['dębow','#8a6a45'],['debow','#8a6a45'],
    ['dąb','#8a6a45'],['dab','#8a6a45'],['pomarańcz','#d98a3a'],['pomarancz','#d98a3a'],['fiolet','#7a5a8a'],
    ['turkus','#3aa0a0'],['miętow','#9ec5a8'],['mietow','#9ec5a8'],['przezrocz','#dfe6e6'],['transparent','#dfe6e6'],
    ['miedz','#b06a3a'],['mosiądz','#c2a05a'],['mosiadz','#c2a05a'],['mosiąd','#c2a05a'],['mosiad','#c2a05a'],
    ['bursztyn','#cc8e3c'],['bursztyn','#cc8e3c'],['chrom','#cfcfcf'],['bronz','#8a6a3a'],['bronze','#8a6a3a'],
    ['słoniow','#efe6d2'],['sloniow','#efe6d2'],['kość','#efe6d2'],['kosc','#efe6d2'],['zachód','#d98a5a'],['zachod','#d98a5a'],
    ['drewn','#b08a5a'],['naturaln','#c8b79a'],['kremow','#efe8da'],['krem','#efe8da'],['blanco','#f4f1ea'],['oro','#c9a24e'],
    ['jasny','#e8e2d6'],['jasn','#e8e2d6'],['ciemny','#3a3630'],['ciemn','#3a3630']
  ];
  function colorFor(name) {
    name = (name || '').toLowerCase();
    for (var i = 0; i < CMAP.length; i++) { if (name.indexOf(CMAP[i][0]) > -1) return CMAP[i][1]; }
    return null;
  }
  function paint() {
    var fsets = document.querySelectorAll('.variant-option--swatches');
    for (var f = 0; f < fsets.length; f++) {
      var labels = fsets[f].querySelectorAll('.variant-option__button-label--has-swatch');
      if (!labels.length) continue;
      // echte variant-FOTO's? dan verschillen de achtergrond-afbeeldingen per waarde -> met rust laten.
      // zo niet (allemaal dezelfde fallback-foto, of geen foto) -> vullen met kleur.
      var uniq = {}, n = 0;
      for (var j = 0; j < labels.length; j++) {
        var s0 = labels[j].querySelector('.swatch');
        if (s0) { uniq[getComputedStyle(s0).backgroundImage] = 1; n++; }
      }
      var distinctImages = Object.keys(uniq).filter(function (k) { return k !== 'none'; }).length;
      if (distinctImages >= 2) continue; // echte variant-foto's -> niet aanraken
      for (var i = 0; i < labels.length; i++) {
        if (labels[i].getAttribute('data-sns-sw')) continue;
        var input = labels[i].querySelector('input');
        var sw = labels[i].querySelector('.swatch');
        if (!input || !sw) continue;
        var c = colorFor(input.value || input.getAttribute('aria-label') || '');
        if (c) { sw.style.backgroundColor = c; sw.style.backgroundImage = 'none'; labels[i].setAttribute('data-sns-sw', '1'); }
      }
    }
  }
  // 2e pass: kleur-opties die als TEKSTknoppen renderen (optienaam met spaties -> niet als swatch herkend).
  // Voeg een kleurstip toe vóór de tekst. Draft-only, raakt geen productdata.
  function paintButtons() {
    var fsets = document.querySelectorAll('.variant-option--buttons:not(.variant-option--swatches)');
    for (var f = 0; f < fsets.length; f++) {
      var leg = fsets[f].querySelector('legend, .variant-option__label, label');
      var nm = ((leg ? leg.textContent : '') || '').trim().toLowerCase();
      if (nm.indexOf('kolor') !== 0 && nm.indexOf('color') !== 0 && nm.indexOf('colour') !== 0) continue;
      var labels = fsets[f].querySelectorAll('.variant-option__button-label');
      for (var i = 0; i < labels.length; i++) {
        if (labels[i].getAttribute('data-sns-sw')) continue;
        var inp = labels[i].querySelector('input');
        if (!inp) continue;
        var c = colorFor(inp.value || inp.getAttribute('aria-label') || '');
        if (!c) continue;
        var dot = document.createElement('span');
        dot.className = 'sns-swdot';
        dot.style.backgroundColor = c;
        labels[i].insertBefore(dot, inp.nextSibling);
        labels[i].setAttribute('data-sns-sw', '1');
      }
    }
  }
  function run() { paint(); paintButtons(); }
  function init() {
    run();
    try {
      var mo = new MutationObserver(function () { run(); });
      mo.observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
